module.exports = __webpack_public_path__ + "images/rich_heading/hobby_fashion/minicar/icon_cbb6b2fc7b5655205ee32a57cc9ffe15.png";